import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// tailwind-merge ne connaît pas les classes custom du DS. Sans cette config,
// il ne peut pas détecter les conflits entre deux classes du même groupe
// (ex: `text-p1 text-h2` → il garderait les deux au lieu de dédupliquer,
// `rounded-ds-1 rounded-ds-2` → idem). On étend chaque classGroup concerné
// avec les tokens DS pour que twMerge les traite comme des classes Tailwind natives.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-h1', 'text-h2', 'text-h3', 'text-h4', 'text-p1', 'text-p2', 'text-p3'],
      rounded: ['rounded-ds-1', 'rounded-ds-2', 'rounded-ds-3'],
      p: ['p-card', 'p-notif', 'p-input', 'p-content', 'p-section'],
      px: ['px-content', 'px-content-sm', 'px-container-margin-big', 'px-section', 'px-breadcrumb'],
      py: ['py-section'],
      'max-w': ['max-w-container-max-w', 'max-w-container-max-w-big', 'max-w-container-small'],
      gap: ['gap-card', 'gap-content', 'gap-content-sm'],
      h: ['h-input', 'h-cta']
    }
  }
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
